import React from 'react';

import DateRangeSelect from '../date_range_select';
import CountryFilter from './country_filter';
import SiteFilter from '../reportable_events/site_filter';

import styles from './filters.module.css';

// The filter bar is shared by every metric card: a change here re-filters the whole page at once,
// so a program manager compares the same Country/Site/Date slice across all metrics.
export default function Filters({ countries, sites, filters, onChange, onReset, isFiltered }) {
  return (
    <div className={styles.bar}>
      <div className={styles.selects}>
        <CountryFilter
          countries={countries}
          onChange={(selected) => onChange({ countries: selected })}
          selected={filters.countries}
        />

        <SiteFilter onChange={(siteIds) => onChange({ siteIds })} selectedIds={filters.siteIds} sites={sites} />

        <DateRangeSelect
          labelId='program-insights-date-filter-label'
          onChange={(dateRange) => onChange({ dateRange })}
          value={filters.dateRange}
        />

        {isFiltered && (
          <button className={styles.reset} onClick={onReset} type='button'>
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
}
